import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Back from "../../components/button/back";

const Absensi = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [siswa, setSiswa] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tahun, setTahun] = useState("");
  const [semester, setSemester] = useState("");
  const [tanggal, setTanggal] = useState("");
  const [kelas, setKelas] = useState("");
  const [rombel, setRombel] = useState("");
  const [attendance, setAttendance] = useState({});

  useEffect(() => {
    const currentDate = new Date();
    setTahun(currentDate.getFullYear());
    setTanggal(currentDate.toISOString().split("T")[0]);
  }, []);

  useEffect(() => {
    const fetchSiswa = async () => {
      if (!kelas || !rombel) return;

      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Silakan login terlebih dahulu.");

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/auth/users`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { tahun, semester, kelas, rombel },
          },
        );

        const siswaData = response.data.filter((s) => s.role === "siswa");
        const filterkelasrombel = siswaData.filter(
          (s) => s.kelas === kelas && s.rombel === rombel,
        );
        setSiswa(filterkelasrombel);
      } catch (err) {
        setError(err.response?.data?.msg || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSiswa();
  }, [tahun, semester, kelas, rombel]);

  const handleAttendanceChange = (studentId, type, value) => {
    setAttendance((prev) => ({
      ...prev,
      [studentId]: {
        ...prev[studentId],
        [type]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Silakan login terlebih dahulu.");

      const absensiData = siswa.map((s) => ({
        siswaId: s._id,
        namaSiswa: s.name,
        sakit: attendance[s._id]?.sakit || 0,
        izin: attendance[s._id]?.izin || 0,
        tanpa_keterangan: attendance[s._id]?.tanpa_keterangan || 0,
      }));

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}api/absensi`,
        { tahun, semester, tanggal, kelas, rombel, siswa: absensiData },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (response.data.message === "Data sudah ada") {
        alert("Data absensi dengan tanggal, kelas, dan rombel ini sudah ada.");
      } else {
        alert("Absensi berhasil disimpan!");
      }
    } catch (err) {
      alert(err.response?.data?.msg || "Gagal menyimpan absensi.");
    }
  };

  if (loading) return <div className="text-center">Loading...</div>;
  if (error)
    return <div className="text-red-500 text-center">Error: {error}</div>;

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-6">
      {/* ===== JUDUL ===== */}
      <h1 className="text-xl md:text-2xl font-bold text-center mb-6">
        Buat Absen Hari Ini
      </h1>

      {/* ===== FORM FILTER ===== */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {/* Tahun */}
          <label className="flex flex-col">
            <span className="text-sm font-medium mb-1">Tahun</span>
            <input
              type="text"
              value={tahun}
              onChange={(e) => setTahun(e.target.value)}
              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </label>

          {/* Semester */}
          <label className="flex flex-col">
            <span className="text-sm font-medium mb-1">Semester</span>
            <select
              value={semester}
              onChange={(e) => setSemester(e.target.value)}
              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <option value="">Pilih</option>
              <option value="1">1</option>
              <option value="2">2</option>
            </select>
          </label>

          {/* Tanggal */}
          <label className="flex flex-col">
            <span className="text-sm font-medium mb-1">Tanggal</span>
            <input
              type="date"
              value={tanggal}
              onChange={(e) => setTanggal(e.target.value)}
              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </label>

          {/* Kelas */}
          <label className="flex flex-col">
            <span className="text-sm font-medium mb-1">Kelas</span>
            <select
              value={kelas}
              onChange={(e) => setKelas(e.target.value)}
              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <option value="">Pilih</option>
              {["1", "2", "3", "4", "5", "6"].map((k) => (
                <option key={k} value={k}>
                  {k}
                </option>
              ))}
            </select>
          </label>

          {/* Rombel */}
          <label className="flex flex-col">
            <span className="text-sm font-medium mb-1">Rombel</span>
            <select
              value={rombel}
              onChange={(e) => setRombel(e.target.value)}
              className="border rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
            >
              <option value="">Pilih</option>
              {["A", "B", "C", "D"].map((r) => (
                <option key={r} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      {/* ===== TABEL ABSENSI ===== */}
      <div className="max-w-7xl mx-auto overflow-x-auto border rounded-md bg-white">
        <table className="w-full border-collapse text-sm">
          <thead className="bg-gray-200">
            <tr>
              <th className="p-3 text-left">Nama</th>
              <th className="p-3 text-center">Sakit</th>
              <th className="p-3 text-center">Izin</th>
              <th className="p-3 text-center">Alpa</th>
            </tr>
          </thead>
          <tbody>
            {siswa.map((s, i) => (
              <tr
                key={s._id}
                className={`border-t ${
                  i % 2 === 0 ? "bg-gray-50" : "bg-white"
                }`}
              >
                <td className="p-3 font-medium">{s.name}</td>

                {["sakit", "izin", "tanpa_keterangan"].map((type) => (
                  <td key={type} className="p-2 text-center">
                    <select
                      value={attendance[s._id]?.[type] || 0}
                      onChange={(e) =>
                        handleAttendanceChange(
                          s._id,
                          type,
                          parseInt(e.target.value),
                        )
                      }
                      className="border rounded-md px-2 py-1 focus:ring-2 focus:ring-blue-400"
                    >
                      <option value={0}>0</option>
                      <option value={1}>1</option>
                    </select>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ===== BUTTON SIMPAN ===== */}
      <div className="flex justify-center mt-6">
        <button
          onClick={handleSubmit}
          className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition"
        >
          Simpan Absensi
        </button>
      </div>

      {/* ===== REKAP ===== */}
      {/* <div className="mt-10 text-center">
        <h2 className="font-bold text-lg mb-3">Daftar Absen Akhir</h2>
        <TotalAbsen />
      </div> */}

      {/* ===== EDIT ===== */}
      {/* <div className="flex justify-center mt-6">
        <button
          onClick={() => navigate(`/absensi/edit/${id}`)}
          className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-600 transition"
        >
          Edit Absensi
        </button>
      </div> */}

      {/* ===== BACK ===== */}
      <div
        className="flex justify-center mt-6 cursor-pointer"
        onClick={() => navigate(`/absensi/${id}`)}
      >
        <Back />
      </div>
    </div>
  );
};

export default Absensi;
